module.exports = __webpack_public_path__ + "media/images/banner/tjt/pc/travel202309_05_770_280_th-dac44a8aa77c681e6abff20036a6eda7.jpg";